import { useCallback, useMemo } from 'react';
import { noop } from 'lodash';

import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import Form from '@/components/Form';
import adaptFormValues from '@/modules/corporate/modules/check-in/views/CheckInDetails/components/AgendaItem/components/Details/utils/adaptFormValues';
import validateForm from '@/modules/corporate/modules/database/views/FormView/components/DatabaseFormConfigurator/utils/validateForm';
import { adaptFormEditorFields } from '@/modules/corporate/modules/database/views/FormView/utils';
import formOverrides from '@/modules/corporate/modules/database/views/FormView/utils/formOverrides';

import { DatabaseFormProps } from './types';

function DatabaseForm(props: DatabaseFormProps) {
  const { t } = useTranslation(['Database']);
  const {
    fields,
    className = 'h-full py-24 px-32',
    onSubmit,
    initialValues,
    fieldOverrides,
    setFormikSubmit,
    onChange,
  } = props;
  const adaptedFields = useMemo(
    () =>
      adaptFormEditorFields({ isFieldPublished: () => true, t, fields, overrides: fieldOverrides }),
    [t, fields, fieldOverrides],
  );

  const adaptedInitialValues = adaptFormValues({ data: initialValues, fields });

  const validate = useCallback((values: any) => validateForm({ values, t, fields }), [fields, t]);

  return (
    <Box className={className}>
      <Form
        fields={adaptedFields}
        formName="DatabaseForm"
        initialValues={adaptedInitialValues}
        overrides={formOverrides}
        setSubmitRef={setFormikSubmit}
        validate={validate}
        onChange={onChange}
        onSubmit={onSubmit || noop}
      />
    </Box>
  );
}

export default DatabaseForm;
